/**
 * Build a localStorage key scoped to a specific user + company.
 * Falls back to the bare base key when IDs are unavailable (e.g. before login).
 */
export function scopedKey(base: string, userId?: string, companyId?: string): string {
  if (userId && companyId) return `${base}_${companyId}_${userId}`;
  return base;
}
